import React from 'react';
import NextLink from 'next/link';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { FADE_ANIMATION_DURATION } from '../../ProductCard.styled';
import * as Styled from './ProductCardImage.styled';
import Badge from '../../../Badge/Badge';
import ImageCarousel from '../ImageCarousel/ImageCarousel';
var ProductCardImage = function (_a) {
    var _b;
    var badge = _a.badge, currentColor = _a.currentColor, _c = _a.images, images = _c === void 0 ? [] : _c, _d = _a.isHovered, isHovered = _d === void 0 ? false : _d, onClick = _a.onClick, pdpLink = _a.pdpLink, productCardPosition = _a.productCardPosition, renderImageOverlay = _a.renderImageOverlay, shopifyId = _a.shopifyId, title = _a.title, dataLabel = _a.dataLabel;
    /**
     * Should render if there is only one image available
     */
    var singleImage = (React.createElement(NextLink, { href: pdpLink, onClick: onClick, "aria-label": title, tabIndex: -1, "data-label": dataLabel || 'productCard_primary', draggable: "false" },
        React.createElement(TransitionGroup, null,
            React.createElement(CSSTransition, { key: currentColor === null || currentColor === void 0 ? void 0 : currentColor.title, classNames: "fade", timeout: FADE_ANIMATION_DURATION },
                React.createElement(Styled.Image, { src: 
                    // An undefined src prop ensures that image does not render broken; Image component will render a gray box
                    ((_b = images[0]) === null || _b === void 0 ? void 0 : _b.src)
                        ? images[0].src.includes('https://')
                            ? images[0].src
                            : "https://".concat(images[0].src)
                        : undefined, alt: title, draggable: "false", isLazy: false, withProgressiveLoading: false })))));
    var multipleImages = (React.createElement(ImageCarousel, { images: images, onClick: onClick, pdpLink: pdpLink, productTitle: title, isHovered: isHovered, shouldChangeOnHover: true, dataLabel: dataLabel, productCardPosition: productCardPosition, shopifyId: shopifyId, key: currentColor === null || currentColor === void 0 ? void 0 : currentColor.id }));
    var getVariation = function () {
        if (!(images === null || images === void 0 ? void 0 : images.length) || images.length === 1) {
            return singleImage;
        }
        return multipleImages;
    };
    return (React.createElement(Styled.ImageContainer, null,
        React.createElement(Styled.VariantImageContainer, null,
            badge && React.createElement(Badge, { text: badge }),
            getVariation()),
        renderImageOverlay && renderImageOverlay({ isVisible: isHovered })));
};
export default ProductCardImage;
